import React from 'react';
import { Link } from 'react-router-dom';
import {Accordion, AccordionDetails, AccordionSummary, Button, Typography} from '@mui/material';
import { useEvents } from '../../context';

import classes from './service.module.scss';
import { ServiceAccordion, ServiceAccordionProps } from '..';
import {ExpandMore} from "@mui/icons-material";

interface CompanyServicesProps {
    company: string;
    services: Array<ServiceAccordionProps>;
    link?: string;
    href?: string;
    contactLink?: string;
    attention?: any;
}

export const ServicesCompany: React.FC<CompanyServicesProps> = React.memo(
    ({ company, services, link, href, contactLink, attention }) => {
        const { contactValueHandler, queryAttentionHandler } = useEvents();
      const [expanded, setExpanded] = React.useState<string | false>(false);

      const handleChange = (panel: string) => () => {
        setExpanded(panel === expanded ? false : panel);
      };
        return (
            <div className={classes.service}>
              <Accordion
                expanded={expanded === company}
                // disabled={!details}

                onChange={handleChange(company)}
                className={classes.service__accordion}
                style={{ cursor: 'pointer'  }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  style={{
                    borderBottom: '1px solid rgba(0, 0, 0, .125)',
                    cursor: 'pointer'
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: '1.1rem',
                      fontWeight: 600
                    }}
                  >
                    {company}
                  </Typography>
                </AccordionSummary>
                {/*<h1 className={classes.service__name}>{}</h1>*/}

                <AccordionDetails
                  className={classes.service__accordion__details}
                >
                  {services.map(service => (
                      <ServiceAccordion
                          key={service.Summary}
                          Summary={service.Summary}
                          Details={service.Details}
                      />
                  ))}
                </AccordionDetails>
              </Accordion>
                <div className={classes.service__actions}>
                    {link ? (
                        <Button
                            component={Link}
                            to={link}
                            variant='contained'
                            color='primary'
                            className={classes.service__actions__book}
                        >
                            Book Appointment
                        </Button>
                    ) : (
                        href && (
                            <Button
                                component='a'
                                href={href}
                                target='_blank'
                                rel='noopener noreferrer'
                                variant='contained'
                                color='primary'
                                className={classes.service__actions__book}
                            >
                                Book Appointment
                            </Button>
                        )
                    )}
                    {contactLink && attention && (
                        <Button
                            component={Link}
                            to={contactLink}
                            variant='contained'
                            color='secondary'
                            className={classes.service__actions__contact}
                            onClick={() => {
                                contactValueHandler(1);
                                queryAttentionHandler(attention);
                            }}
                        >
                            Contact Us
                        </Button>
                    )}
                </div>
            </div>
        );
    }
);
